import { InteractionStepType } from '@scale/shared/types/chat';
import { StepConfigurationComponentProps } from '../stepDescriptor/types';

export function SpanFeedbackConfigurationComponent(
  _props: StepConfigurationComponentProps<InteractionStepType.SpanFeedback>,
) {
  return <div>Span Feedback Configuration</div>;
}
